import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useSettingsStore } from '@@scripts/store/settings/useSettingsStore';

/**
 * Runs the loaders again when the content language changes, from the user settings, a list's
 * language switch or a preference PATCH that another tab made. List loaders read the language
 * while a page loads, and their queries are keyed by it.
 */
export const useReloadOnContentLanguageChange = () => {
    const router = useRouter();

    useEffect(
        () =>
            useSettingsStore.subscribe(
                (state) => state.contentLocale,
                () => router.invalidate(),
            ),
        [router],
    );
};
